import React, { useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'terms' | 'privacy' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="bg-[#1a1f3a] text-[#faf8f5] py-8" data-id="element-32">
        <div className="container mx-auto px-6" data-id="element-33">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-34">
            <p className="text-sm text-gray-400" data-id="element-35">
              © {new Date().getFullYear()} Guía de Reinicio de Energía. Todos
              los derechos reservados.
            </p>
            <div className="flex gap-6" data-id="element-36">
              <button onClick={() => setActiveModal('terms')} className="text-sm text-gray-400 hover:text-[#d4a574] transition-colors" data-id="element-37">
                Términos y Condiciones
              </button>
              <button onClick={() => setActiveModal('privacy')} className="text-sm text-gray-400 hover:text-[#d4a574] transition-colors" data-id="element-38">
                Política de Privacidad
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={closeModal} data-id="element-39">
          <div className="bg-[#faf8f5] rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-40">
            {/* Modal Header */}
            <div className="bg-[#1a1f3a] px-6 py-4 flex justify-between items-center" data-id="element-41">
              <h2 className="text-xl font-bold text-[#faf8f5]" data-id="element-42">
                {activeModal === 'terms' ? 'Términos y Condiciones' : 'Política de Privacidad'}
              </h2>
              <button onClick={closeModal} className="text-gray-400 hover:text-white transition-colors" data-id="element-43">
                <X className="w-6 h-6" data-id="element-44" />
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-[#1a1f3a]" data-id="element-45">
              {activeModal === 'terms' ? <div className="space-y-4 text-sm leading-relaxed" data-id="element-46">
                  <p className="text-gray-600" data-id="element-47">
                    Última actualización:{' '}
                    {new Date().toLocaleDateString('es-ES')}
                  </p>

                  <h3 className="font-bold text-lg mt-6" data-id="element-48">
                    1. Aceptación de los Términos
                  </h3>
                  <p data-id="element-49">
                    Al acceder y utilizar este sitio web y adquirir la Guía de
                    Reinicio de Energía, aceptas estar sujeto a estos términos y
                    condiciones de uso.
                  </p>

                  <h3 className="font-bold text-lg mt-6" data-id="element-50">
                    2. Descripción del Producto
                  </h3>
                  <p data-id="element-51">
                    La Guía de Reinicio de Energía es un producto digital
                    educativo que proporciona información sobre hábitos de
                    bienestar y energía. Este contenido es únicamente
                    informativo y no sustituye el consejo médico profesional.
                  </p>

                  <h3 className="font-bold text-lg mt-6" data-id="element-52">
                    3. Uso del Producto
                  </h3>
                  <p data-id="element-53">
                    El contenido adquirido es para uso personal y no comercial.
                    Queda prohibida la reproducción, distribución o reventa del
                    material sin autorización expresa.
                  </p>

                  <h3 className="font-bold text-lg mt-6" data-id="element-54">
                    4. Política de Reembolso
                  </h3>
                  <p data-id="element-55">
                    Debido a la naturaleza digital del producto, no se ofrecen
                    reembolsos una vez realizada la compra y entregado el acceso
                    al contenido.
                  </p>

                  <h3 className="font-bold text-lg mt-6" data-id="element-56">
                    5. Limitación de Responsabilidad
                  </h3>
                  <p data-id="element-57">
                    Los resultados pueden variar según cada persona. No
                    garantizamos resultados específicos. Consulta siempre con un
                    profesional de la salud antes de realizar cambios
                    significativos en tu estilo de vida.
                  </p>

                  <h3 className="font-bold text-lg mt-6" data-id="element-58">6. Modificaciones</h3>
                  <p data-id="element-59">
                    Nos reservamos el derecho de modificar estos términos en
                    cualquier momento. Los cambios serán efectivos
                    inmediatamente después de su publicación.
                  </p>
                </div> : <div className="space-y-4 text-sm leading-relaxed" data-id="element-60">
                  <p className="text-gray-600" data-id="element-61">
                    Última actualización:{' '}
                    {new Date().toLocaleDateString('es-ES')}
                  </p>

                  <h3 className="font-bold text-lg mt-6" data-id="element-62">
                    1. Información que Recopilamos
                  </h3>
                  <p data-id="element-63">
                    Recopilamos información personal que nos proporcionas
                    voluntariamente al realizar una compra, incluyendo: nombre,
                    dirección de correo electrónico e información de pago.
                  </p>

                  <h3 className="font-bold text-lg mt-6" data-id="element-64">
                    2. Uso de la Información
                  </h3>
                  <p data-id="element-65">Utilizamos tu información para:</p>
                  <ul className="list-disc pl-6 space-y-1" data-id="element-66">
                    <li data-id="element-67">Procesar tu compra y entregar el producto digital</li>
                    <li data-id="element-68">Enviarte comunicaciones relacionadas con tu compra</li>
                    <li data-id="element-69">Mejorar nuestros productos y servicios</li>
                  </ul>

                  <h3 className="font-bold text-lg mt-6" data-id="element-70">
                    3. Protección de Datos
                  </h3>
                  <p data-id="element-71">
                    Implementamos medidas de seguridad técnicas y organizativas
                    para proteger tu información personal contra acceso no
                    autorizado, pérdida o alteración.
                  </p>

                  <h3 className="font-bold text-lg mt-6" data-id="element-72">4. Cookies</h3>
                  <p data-id="element-73">
                    Utilizamos cookies para mejorar tu experiencia de navegación
                    y analizar el tráfico del sitio. Puedes configurar tu
                    navegador para rechazar cookies.
                  </p>

                  <h3 className="font-bold text-lg mt-6" data-id="element-74">5. Terceros</h3>
                  <p data-id="element-75">
                    No vendemos ni compartimos tu información personal con
                    terceros, excepto cuando sea necesario para procesar pagos o
                    cumplir con obligaciones legales.
                  </p>

                  <h3 className="font-bold text-lg mt-6" data-id="element-76">6. Tus Derechos</h3>
                  <p data-id="element-77">
                    Tienes derecho a acceder, rectificar o eliminar tu
                    información personal. Para ejercer estos derechos,
                    contáctanos a través de los canales disponibles.
                  </p>

                  <h3 className="font-bold text-lg mt-6" data-id="element-78">
                    7. Cambios en esta Política
                  </h3>
                  <p data-id="element-79">
                    Podemos actualizar esta política periódicamente. Te
                    notificaremos sobre cambios significativos publicando la
                    nueva política en este sitio.
                  </p>
                </div>}
            </div>
          </div>
        </div>}
    </>;
}